// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"5fcb6f5c","126":"1d02ad0c","171":"9b5f8029","378":"d22308bc","453":"4d22c758"}[chunkId] + ".chunk.js";
};